(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-by-category-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".tab");
  const items = document.querySelectorAll(".category-item");

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      tabs.forEach(t => t.classList.remove("active"));
      tab.classList.add("active");

      const category = tab.dataset.tab;

      items.forEach(item => {
        item.classList.toggle(
          "active",
          category === "all" || item.dataset.category === category
        );
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
